function __isGxpEntryPoint() {
  return window.location.href.indexOf('inventory/search') > -1 // GXP search results
  || window.location.href.indexOf('inventory/details') > -1; // GXP inv detail
}

function __isBatEntry() {
  return window.location.href.indexOf('inventory/results') > -1 // BAT search results
  || window.location.href.indexOf('inventory-detail') > -1; // Bat inv detail
}

export default {
  isGxpEntry: __isGxpEntryPoint(),
  isBatEntry: __isBatEntry()
};
